<template>
    <div class="main-layout page-register">
        <LoadingSSO :isShow="loading" />
        <img src="@/assets/ssoauth/iconsso.svg" class="img-head" />
        <div class="content-page-wrapper">
            <div class="content-page">
                <div class="page-card form-register">
                    <FormProfile
                        ref="formProfile"
                        class=""
                        :data="data"
                        :isFirstSave="isFirstSave"
                        :isHideEditContact="true"
                        :profile="profile"
                        :address="address"
                        @onFormChange="isValidatePass"
                    />
                    <div class="mt-3"></div>
                    <ModalPDPA
                        ref="acceptData"
                        v-model="acceptData"
                        :text="textAccept"
                        :check="acceptData"
                        :check2="acceptDataPromo"
                        :isFirstSave="isFirstSave"
                        @input="changePDPA($event)"
                        @inputPromo="changePDPAPromo($event)"
                    />
                    <!-- <ModalNews
                        v-model="acceptNews"
                        :text="textTerm"
                        :check="acceptNews"
                        @input="changeTerm($event)"
                    /> -->
                    <div class="btn-submit-wrapper">
                        <div
                            id="register-submit-btn"
                            class="btn-submit"
                            @click="clickSave()"
                        >
                            ลงทะเบียน
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="modalRegister"
            modal-class="modal-register"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div v-if="popupData.InformationRecieved" class="modal-base">
                <div clas="">
                    <div class="col-12 text-center mt-2">
                        <div class="title-scc">
                            {{ popupData.InformationRecieved.header }}
                        </div>
                        <div
                            class="desc-scc"
                            v-html="popupData.InformationRecieved.desc"
                        ></div>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal
            id="modalAlertRegister"
            modal-class="modal-alert-register"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base">
                <div class="col-12 text-center mt-2">
                    <div class="title-scc">
                        {{
                            popupData.ValidationCodeExpire
                                ? popupData.ValidationCodeExpire.header
                                : ""
                        }}
                    </div>
                    <div class="desc-scc" v-html="errmsg"></div>
                    <div class="btn" @click="onClickAlertModal">ตกลง</div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from "vue";
import Moment from "moment";
import ConfigManager from "@/config/ConfigManager.js";
// hepler
import CacheHelper from "@/helper/CacheHelper.js";
import AccountHelper from "@/helper/AccountHelper.js";

// mixins
import ModalMixin from "@/mixin/ModalMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import ModalFactory from "@/components/Modal/ModalFactory.js";
// component
// import ModalNews from "@/module/Register/component/ModalNews.vue";
import ModalPDPA from "@/module/Register/component/ModalPDPA.vue";
import FormProfile from "@/module/Register/component/FormRegister.vue";
import LoadingSSO from "@/components/LoadingSSO/Loading.vue";
//helper
import { TrackingService } from "@/helper/TrackingHelper.js";
// model
import BzbsAuth from "@/core/Account/service/BzbsAuth.js"; // service
import RegisterService from "@/module/Register/service/RegisterService.js";

export default {
    name: "register",
    components: {
        FormProfile,
        // ModalNews,
        ModalPDPA,
        LoadingSSO
    },
    props: {
        data: Object
    },
    mixins: [ModalMixin, ErrorApiMixin],
    watch: {
        // acceptNews: function() {
        //     this.isValidatePass();
        //     // this.tracking.event('register_pdpa','click_accept_register');
        // },
        acceptData: function() {
            this.isValidatePass();
            // this.tracking.event('register_pdpa','click_marketplace_menu');
        }
    },
    data: function() {
        return {
            loading: false,
            modalFactory: new ModalFactory(),
            isFirstSave: true,
            textTerm: null,
            textAccept: null,
            isDisabledSubmit: true,
            // acceptNews: false,
            acceptData: false,
            idLineToken: null,
            isNewUser: true,
            isLoaded: false,
            profile: {},
            address: {},
            trackingPage: "register",
            trackingCat: "register_otp",
            tracking: new TrackingService(this),
            checkRegister: null,
            pdpaVersion: [],
            popupData: {},
            acceptDataPromo: false,
            errmsg: ""
        };
    },
    created() {
        this.loading = true;
        document.body.classList.add("body-sso");
        window.gtag("event", "conversion", {
            send_to: "AW-970877309/3B3cCL_206EDEP3S-c4D"
        });

        window._lt(
            "send",
            "cv",
            {
                type: "RegisterPageView"
            },
            ["2360d21e-79ce-4697-9bc0-02f5f2555aef"]
        );

        window.gtag_report_conversion(
            window.location.href,
            "AW-970877309/J6dhCOzGp6EDEP3S-c4D"
        );

        var cacheHelper = new CacheHelper("cookie");
        this.idLineToken = cacheHelper.getCache("linetoken");
        this.checkRegister = cacheHelper.getCache("BzbsUser");

        Promise.all([this.getBlob(), this.getTerm(), this.getPrivacy()]).then(
            () => {
                this.loading = false;
            }
        );
    },
    methods: {
        getTerm() {
            return new Promise(resolve => {
                RegisterService.getTerm().then(response => {
                    this.pdpaVersion.terms = response;
                    resolve(response);
                });
            });
        },
        getPrivacy() {
            return new Promise(resolve => {
                RegisterService.getPrivacy(this.locale).then(response => {
                    this.pdpaVersion.privacy = response;
                    resolve(response);
                });
            });
        },

        changePDPA(value) {
            this.acceptData = value;
        },
        changePDPAPromo(value) {
            this.acceptDataPromo = value;
        },
        apiLoginLine: async function(idLineToken) {
            return new Promise((resolve, reject) => {
                BzbsAuth.apiLoginLineService(idLineToken).subscribe(
                    data => {
                        resolve(data, "data");
                    },
                    err => {
                        this.errorResponse(err);

                        reject(err);
                    }
                );
            });
        },
        clickSave() {
            this.isFirstSave = false;
            var targetForm = this.$refs["formProfile"];

            window.gtag_report_conversion(
                window.location.href,
                "AW-970877309/g_UhCIbxpaEDEP3S-c4D"
            );

            window.fbq("trackCustom", "RegisterButton");

            window._lt(
                "send",
                "cv",
                {
                    type: "RegisterButton"
                },
                ["2360d21e-79ce-4697-9bc0-02f5f2555aef"]
            );

            // valite data
            if (this.isValidatePass()) {
                var form = targetForm.getFormDataFormat().register;
                var params = {
                    id_token: this.idLineToken,
                    appId: ConfigManager.getAppId(),
                    firstname: form.strFirstname,
                    lastname: form.strLastname,
                    birthdate: Moment.unix(form.strBirthDate)
                        .utc()
                        .format("YYYY-MM-DD"),
                    contactNumber: form.strContactNumber,
                    gender: form.strGender,
                    provinceName: form.strProvince.province_name,
                    provinceCode: form.strProvince.province_code,
                    marketingOption: this.acceptDataPromo ? "1" : "",
                    email: this.acceptDataPromo ? true : false,
                    sms: this.acceptDataPromo ? true : false,
                    notification: this.acceptDataPromo ? true : false,
                    line: this.acceptDataPromo ? true : false,
                    ussd: this.acceptDataPromo ? true : false,
                    validationCode: this.data.validationCode,
                    termandcondition: this.pdpaVersion.terms,
                    dataprivacy: this.pdpaVersion.privacy
                };
                if (Vue.$cookies.get("ref_type")) {
                    params.reftype = Vue.$cookies.get("ref_type");
                    Vue.$cookies.remove("ref_type");
                }
                if (Vue.$cookies.get("ref_code")) {
                    params.refcode = Vue.$cookies.get("ref_code");
                    Vue.$cookies.remove("ref_code");
                }
                this.callRegisterApi(params).then(() => {
                    this.loading = false;
                    this.$bvModal.show("modalRegister");
                    setTimeout(() => {
                        this.$bvModal.hide("modalRegister");
                        window.location.href = `${this.popupData.InformationRecieved.url}`;
                    }, 2000);
                });
            }
        },
        getBlob() {
            return new Promise((resolve, reject) => {
                BzbsAuth.getBlob().then(
                    response => {
                        this.popupData = response;
                        resolve(true);
                    },
                    err => {
                        this.errorResponse(err);
                        reject(err);
                    }
                );
            });
        },
        callRegisterApi(form) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                BzbsAuth.apiRegister(form).subscribe(
                    data => {
                        AccountHelper.bzbsAnalyticTracking({
                            ScreenName: "register",
                            Category: "register",
                            Event: "register_success",
                            Action: "on view",
                            ContactNumber: form.contactNumber
                        });
                        resolve(data);
                    },
                    err => {
                        this.loading = false;
                        this.errmsg = err.message
                            ? err.message
                            : "Something Error";
                        if (err.code == 401 && err.id == 401) {
                            this.errmsg = this.popupData.ValidationCodeExpire.desc;
                        } else if (err.code == 409 && err.id == 2078) {
                            this.errmsg =
                                "ขออภัยค่ะ หมายเลขโทรศัพท์ของท่านมีอยู่แล้วในระบบ กรุณาตรวจสอบอีกครั้ง หากไม่สามารถแก้ไขได้ กรุณาติดต่อศูนย์บริการลูกค้า โทร. 02-6578625";
                        } else if (err.code == 409 && err.id == 1904) {
                            this.errmsg =
                                "บัญชีไลน์นี้ได้ทำการลงทะเบียนแล้ว ไม่สามารถลงทะเบียนซ้ำได้ กรุณาติดต่อศูนย์บริการลูกค้า โทร. 02-6578625";
                        }
                        this.$bvModal.show("modalAlertRegister");

                        reject(err);
                    }
                );
            });
        },
        onClickAlertModal() {
            window.location.href = this.popupData.ValidationCodeExpire.url;
        },
        isValidatePass() {
            var result = this.$refs["formProfile"].isValidForm();

            if (!this.acceptData) {
                this.$refs["acceptData"].checkData();
                result = false;
            }
            this.isDisabledSubmit = !result;
            return result;
        },
        clickGopage: function(page) {
            window._lt(
                "send",
                "cv",
                {
                    type: "StartButton"
                },
                ["2360d21e-79ce-4697-9bc0-02f5f2555aef"]
            );

            window.gtag_report_conversion(
                window.location.href,
                "AW-970877309/J6dhCOzGp6EDEP3S-c4D"
            );

            if (this.$route.query.target_page) {
                window.location.replace(
                    this.$route.query.target_page +
                        "?target_page=" +
                        this.$route.query.target_page
                );
            } else {
                window.location.href = `${page}`;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/modal.scss";

::v-deep .show.modal-register .modal-dialog .modal-content {
    border-radius: 0px;
}

::v-deep .modal-alert-register .modal-dialog .modal-content {
    text-align: center;
    border-radius: 0;
    background-color: #fff;
    font-family: "DBHeaventRegular" !important;
    font-size: 1.5rem;

    .modal-base-body {
        font-size: 22px;
        color: #65513e;
        // font-weight: bold;
        margin: 15px auto;
    }

    .modal-base-footer .btn-primary {
        width: 55%;
        background: #65513e !important;
        color: #fff;
        padding: 7px 0;
        font-size: 22px;
        margin: 0 auto 15px auto;
        font-family: "DBHeaventRegular";
        border-radius: 5px;
        display: block;
        border: none;
    }
}

::v-deep .modal-pdpa {
    font-family: "DBHeaventRegular";
    font-size: 1em;

    .pdpa-container {
        padding: 0 1.25rem 1.25rem;
    }

    .modal-body .modal-base .modal-base-body p {
        padding: 10px 0;
    }
}

::v-deep .modal-register,
.modal-alert-register {
    border-radius: 0px;

    .modal-base {
        font-family: "DBHeaventRegular";
        padding: 0;
    }

    .modal-body {
        background-color: #fff;
        font-family: "DBHeaventRegular";
        font-size: 1.5rem;
    }

    .title-scc {
        font-size: 22px;
        color: #65513e;
        font-weight: bold;
        margin: 15px auto;
    }

    .desc-scc {
        font-size: 20px;
        color: #666666;
        margin: 0 auto 20px auto;

        img {
            margin-left: 5px;
        }
    }

    .btn {
        width: 55%;
        background: #65513e;
        color: #fff;
        padding: 7px 0;
        font-size: 22px;
        margin: 0 auto 15px auto;
        font-family: "DBHeaventRegular";
        border-radius: 5px;
    }

    .btn-back {
        color: #000;
        padding: 7px 0;
        font-size: 22px;
        border: none;
        text-decoration: underline;
        margin-bottom: 15px;
        font-weight: bold;
        letter-spacing: 1px;
    }
}
</style>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/sso.scss";
</style>
